import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CourtDto } from "../../../models/court/dto/court.dto";
import { CreateCourtInputDto } from "../../../models/court/dto/create-court.dto";
import { GET_COURT_QUERY_KEY } from "./useGetCourt";
import { GET_LOCATION_COURTS_QUERY_KEY } from "./useGetCourts";

export const useCreateCourt = (onSuccess: (data: CourtDto) => void) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['createCourt'],
        mutationFn: (dto: CreateCourtInputDto) => client.fetchApi<CourtDto, CreateCourtInputDto>({ endpoint: 'courts', method: 'POST', body: dto }),
        onSuccess: (data) => {
            queryClient.setQueryData(GET_COURT_QUERY_KEY(data.id), () => data);
            queryClient.setQueryData(GET_LOCATION_COURTS_QUERY_KEY(data.location.id), (old: CourtDto[]) => [...old, data]);
            onSuccess(data);
        }
    });
};